import { merge } from '../../helper';

import * as exElement from '../element';
import { create, settings } from './create';

// ----------------------------------------------------------------------------

function data(element: HTMLElement, config: Record<string, any> = {}): any[] {
    const list: any[] = [];

    // Foreach Data
    for (let item of config.data) {
        // If item is string
        if (typeof item === 'string') {
            item = {
                position: item,
            };
        }

        // If there is element overlay
        if (element.querySelector('.overlay-' + item.position)) {
            continue;
        }

        // Create element (overlay)
        const elOverlay = add(item);
        list.push(elOverlay);
    }

    return list;
}

function add(config: Record<string, any> = {}): HTMLElement {
    // Create element (overlay)
    const elOverlay = exElement.create({
        merge: config,
        class: {
            new: 'overlay',
        },
        style: {
            position: 'absolute',
        },
    });

    if (config.position) {
        elOverlay.addClass('overlay-' + config.position);
    }

    // Switch Position
    switch (config.position) {
        case 'top-left':
        case 'left-top':
            elOverlay.style.top = '0px';
            elOverlay.style.left = '0px';
            break;
        case 'top':
        case 'top-mid':
            elOverlay.style.top = '0px';
            elOverlay.style.left = '50%';
            elOverlay.style.transform = 'translateX(-50%)';
            break;
        case 'top-right':
        case 'right-top':
            elOverlay.style.top = '0px';
            elOverlay.style.right = '0px';
            elOverlay.style.textAlign = 'right';
            break;
        case 'left':
        case 'left-mid':
            elOverlay.style.top = '50%';
            elOverlay.style.left = '0px';
            elOverlay.style.transform = 'translateY(-50%)';
            break;
        case 'center':
        case 'center-mid':
            elOverlay.style.top = '50%';
            elOverlay.style.left = '50%';
            elOverlay.style.transform = 'translate(-50%, -50%)';
            break;
        case 'right':
        case 'right-mid':
            elOverlay.style.top = '50%';
            elOverlay.style.right = '0px';
            elOverlay.style.transform = 'translateY(-50%)';
            break;
        case 'bottom-left':
        case 'left-bottom':
            elOverlay.style.bottom = '0px';
            elOverlay.style.left = '0px';
            break;
        case 'bottom':
        case 'bottom-mid':
            elOverlay.style.bottom = '0px';
            elOverlay.style.left = '50%';
            elOverlay.style.transform = 'translateX(-50%)';
            break;
        case 'bottom-right':
        case 'right-bottom':
            elOverlay.style.bottom = '0px';
            elOverlay.style.right = '0px';
            elOverlay.style.textAlign = 'right';
            break;
        // No default
    }

    // Return
    return elOverlay;
}

// ----------------------------------------------------------------------------

function start(element: HTMLElement, config: Record<string, any> = {}): HTMLElement {
    // Default Config
    const defConfig: Record<string, any> = {
        data: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // Get element (overlays)
    let elOverlays = element.querySelector<HTMLElement>('.overlays');

    // If there element overlays, create
    if (elOverlays) {
        settings(elOverlays, defConfig);
    }
    // If there element overlays, check and update
    else {
        // Create element (overlays)
        elOverlays = create(defConfig);
        element.appendChild(elOverlays);
    }

    // Return
    return elOverlays;
}

// ----------------------------------------------------------------------------

export { data, add, start };
